import {
  Diagram,
  GraphLinksModel,
  GraphObject,
  Spot,
  TreeLayout,
  InputEvent,
} from 'src/util/gojs/go';
import {GOJS_LICENSE_KEY as LICENSE_KEY} from 'src/gojs-license';
import {nameTypeComparer} from 'src/graph';


const {make} = GraphObject;

Diagram.licenseKey = LICENSE_KEY;


export const makeDiagram = ({
  handleContextClick = () => {},
} : {
  handleContextClick?: (e: InputEvent) => void,
} = {}) =>
  make(Diagram, {
    'undoManager.isEnabled': true,
    'contentAlignment': Spot.Left,
    'layout': make(TreeLayout, {
      nodeSpacing: 10,
      layerSpacing: 20,
      sorting: TreeLayout.SortingAscending,
      comparer: nameTypeComparer,
    }),
    'model': make(GraphLinksModel, {
      linkKeyProperty: 'key',
    }),
  }, {
    contextClick: handleContextClick,
  });
